export default "__VITE_ASSET__CvwDp7S3__"